import { useLocation } from "react-router-dom";
import { ERMSInvoiceContent, ERMSReceiptContent } from "../../components/erms";

export default function ERMS() {
    const location = useLocation();
  return (
    <>
      {location.state && location.state.page === "invoice" ? (
        <ERMSInvoiceContent />
      ) : location.state && location.state.page === "receipt" ? (
        <ERMSReceiptContent />
      ) : (
        <ERMSInvoiceContent />
      )}
    </>
  );
}
